import { PERMISSION_KEY } from "@/types/user";

const messagesDE = {
    orderFrom: 'Bestellung bei',
    mobileWeb: "Wir haben gemerkt, dass du versuchst, die Octopus Order Web-Version von einem Mobilgerät aus zu " +
        "öffnen. Für eine bessere Nutzererfahrung empfehlen wir dir, auf Mobilgeräten die Mobile-App aus deinem " +
        "App-Store herunterzuladen und statt der Web-Version zu verwenden. ",
    mobileWeb2: "Über folgende Links gelangst du zur Octopus Order Mobile-App:",
    setting: {
        location: 'Deine Location bearbeiten',
        profile: 'Dein Nutzerprofil bearbeiten',
        delivererAssign: 'Weise deiner Location einen Lieferanten zu',
        delivererSelect: 'Lieferant auswählen',
        inputCustomerNr: 'Kundennummer eintragen',
        changeLocation: 'Location wechseln',
        welcome1: 'Hallo {name}',
        welcome2: 'Hier kannst du wählen',
        welcome3: 'welche Darstellung du bevorzugst'
    },
    emptyCart: 'Leider ist dein Einkaufswagen leer.',
    emptySuggestion: 'Leider haben wir derzeit keine Produktvorschläge für dich.',
    card: {
        forwardPoints: 'Klicke hier um zu unserem @:object.pointSystem weitergeleitet zu werden',
        points: 'Octopus Punkte',
        shop: 'Zum Octopus-Shop',
        currentPromotion: 'Aktuelle Aktionen',
        createLocationExplanation: 'Eine Location kann eine Bar, Restaurant, Hotel, Büro, oder ähnliches Gewerbe sein.',
        productSuggestion: 'Produkt{hyphen}neuheiten und Vorschläge'
    },
    noPromotion: 'Momentan haben wir leider keine Aktion für dich.',
    promotion: {
        order: 'Bestellbar bei',
        octopus: 'Octopus Aktionen',
        deliverer: 'Aktionen deiner Lieferanten',
        articles: 'Diese Artikel haben derzeit einen Aktionspreis'
    },
    home: {
        createLocation: 'Neue @:messages.location.create',
        welcome1: 'Hallo {name}',
        welcome2: 'welche Location darf es sein?',
        image1: 'Gemischt, gezapft, geordert!',
        image2: 'Sicher, digital, bestellen!',
        image3: 'Einfach, schnell, ausliefern!'
    },
    dashboard: {
        catalog: {
            availableProduct: 'Alle verfügbaren Artikel',
            delivererCatalog: 'Sortiment des Lieferanten',
            createProduct: 'Produkt hinzufügen',
            createdCustomProduct: 'Produkt wurde zu Liste hinzugefügt.',
            noReducedSupplier: 'Derzeit bietet keiner deiner Lieferanten Angebote an.'
        },
        home: {
            orders: 'Deine letzten Bestellungen',
            favouriteList: 'Deine zuletzt bestellten Listen',
            news: 'Octopus News'

        },
        list: {
            allLists: 'Alle Listen dieser Location',
            createList: 'Neue @:titleRoute.addList',
            noSupplier: 'Du hast deiner Location bisher noch keinen Lieferanten hinzugefügt. Bitte füge einen ' +
                'Lieferanten über die Einstellungen hinzu.'
        },
        message: {
            available: 'Nachrichten verfügbar'
        },
        setting: {
            order: 'Alles zu deinen Bestellungen auf einen Blick',
            team: 'Übersicht und Verwaltung deines Teams',
            deliverer: 'Hier siehst du deine Lieferanten',
            notification: 'Verwalte hier deine Benachrichtigungen',
            display: 'Wähle zwischen Dark oder Light Mode',
            statistic: 'Hier kannst du deine Auswertungen ansehen',
            imprint: 'Informationen und Rechtliches',
            support: 'Kontakt zu Octopus Order aufnehmen',
            orderNotificationTimer: 'Stelle deine Bestellwecker ein',
            intro: 'Entdecke alle Funktionen der App'
        }
    },
    location: {
        thank: '@:button.thank',
        sendMsg: 'Nachricht Senden',
        create: 'Location hinzufügen',
        requestSent: 'Deine Anfrage bei Lieferant {deliverer} wird überprüft. In den kommenden Tagen wird sich ein ' +
            'Mitarbeiter bei Dir melden.',
        assignDeliverer: 'Weise deiner Location einen Lieferanten zu',
        welcome1: 'Hallo {name}',
        intro: 'In 4 kurzen Schritten vervollständigen wir gemeinsam dein Profil'
    },
    noOrders: 'Du hast noch keine Bestellungen getätigt.',
    noOrdersFilter: 'Du hast in diesem Zeitrahmen keine Bestellungen getätigt.',
    noLists: 'Du hast noch keine Listen erstellt.',
    noNotifications: 'Du hast noch keine Benachrichtigungen erhalten.',
    noNews: 'Leider sind derzeit keine Octopus News vorhanden.',
    order: {
        deliveryType: 'Lieferart auswählen',
        deliveryTime: 'Liefertag auswählen',
        pickupTime: 'Abholzeitpunkt auswählen',
        pickup: 'Abholung',
        delivery: 'Lieferung',
        overview: 'Bestellübersicht',
        choosePayment: 'Zahlungsart wählen',
        redirectPayment: 'Im nachfolgenden Schritt wirst du zu {target} weitergeleitet.',
        rememberPayment: 'Zahlungsart für zukünftige Bestellungen verwenden.',
        voucher: 'Gutschein | Gutscheine',
        redeemVoucher: '@:messages.order.voucher einlösen',
        voucherCode: 'Gutscheincode eingeben',
        currentOrders: 'Meine Bestellungen',
        orderProducts: 'Deine bestellten @:object.article',
        otherProducts: 'Weitere häufig bestellte Artikel',
        sent: 'Ihre Bestellung wurde erfolgreich an {target} übertragen.',
        locationIssue: 'Fehlender Abholort. Bitte gib einen Abholort an.'
    },
    deliverer: {
        allDeliverers: 'Alle @:object.deliverer von {location}',
        addDeliverer: 'Einen @:object.deliverer hinzufügen',
        noEmail: 'Bitte füge dem Lieferanten eine EMail-Adresse hinzu bevor du bestellen kannst',
    },
    team: {
        invite: {
            welcome1: '@:messages.home.welcome1', // und profitiere davon,
            welcome2: 'Lade weitere Mitarbeiter oder Partner zur App ein...',
            copy: 'Oder kopiere einfach den Code und teile ihn:' /*Link*/,
            messenger: 'Lade direkt über den Messenger deiner Wahl ein:',
            mail: 'Per Email Adresse',/*oder Telefonnummer:*/
            joinTeam: 'Trete unserem Team bei',
            joinTeam2: 'Du wurdest zur Location {location} in der Octopus Order App eingeladen!\n\n' +
                'Mit diesem Link kannst du direkt deinem Team beitreten.\n\n{inviteLink}\n\n' +
                'Sollte dieser nicht funktionieren kannst du in der App mit dem Code \n\n{link}\n\n' +
                'deinem neuen Team beitreten.\n\nFür Android: {appLinkAndroid}\n\nFür IOS: {appLinkIOS}',
            shareHint: 'Der generierte/versendete Code kann aus Sicherheitsgründen nur Basis-User einladen. Für eine Einladung mit den selektierten Rechten verwende bitte die E-Mail Einladung.'
        },
        management: {
            members: 'Teammitglieder von {location}',
            inviteMember: 'Teammitglieder einladen',
            addDevice: 'Gerät hinzufügen',
            permissionExplanation: 'Übersicht über die Rechte unserer Rollen:'
        }
    },
    missingPermission: 'Fehlende Berechtigung: {permission}',
    missingCartOrderPermission: 'Deine Berechtigungen in der App reichen nicht aus. Bitte wende dich an den Besitzer ' +
        'deiner Location um eine Bestellung abzuschließen',
    permission: {
        all: 'Alle Rechte',
        locationOrderHistoryRead: 'Bestellungsverlauf lesen',
        locationListRead: 'Listen einsehen',
        [PERMISSION_KEY.LIST_ITEM_READ]: 'Listenprodukte einsehen',
        [PERMISSION_KEY.LIST_ITEM_CREATE]: 'Listenprodukte erstellen',
        [PERMISSION_KEY.LIST_ITEM_UPDATE]: 'Listenprodukte bearbeiten',
        [PERMISSION_KEY.LIST_ITEM_DELETE]: 'Listenprodukte löschen',
        locationListCreate: 'Listen erstellen',
        locationListUpdate: 'Listen bearbeiten',
        locationListDelete: 'Listen löschen',
        locationCartRead: 'Einkaufswagen einsehen',
        locationCartAdd: 'Einkaufswagen befüllen',
        locationCartUpdate: 'Einkaufswagenprodukte bearbeiten',
        locationCartDelete: 'Einkaufswagenprodukte löschen',
        locationOrderCreate: 'Bestellung erstellen',
        locationOrderRequest: 'Bestellungsanfrage ausführen',
        locationRead: 'Location einsehen',
        locationCreate: 'Location erstellen',
        locationUpdate: 'Location bearbeiten',
        locationDelete: 'Location löschen',
        locationTeamRead: 'Team einsehen',
        locationTeamMemberAdd: 'Teammitglied hinzufügen',
        locationTeamMemberDelete: 'Teammitglied löschen',
        locationTeamMemberRoleUpdate: 'Teammitgliedrollen bearbeiten',
        locationSupplierRead: 'Lieferanten einsehen',
        locationSupplierCreate: 'Lieferanten hinzufügen',
        meRead: 'Eigene Benutzerdaten lesen',
        meUpdate: 'Eigene Benutzerdaten bearbeiten',
        meDelete: 'Eigenen Benutzer löschen',
        [PERMISSION_KEY.LIST_REMINDER_CREATE]: 'Bestellwecker erstellen',
        [PERMISSION_KEY.LIST_REMINDER_DELETE]: 'Bestellwecker löschen',
        [PERMISSION_KEY.LIST_REMINDER_READ]: 'Bestellwecker einsehen',
        [PERMISSION_KEY.LIST_REMINDER_UPDATE]: 'Bestellwecker bearbeiten',
        [PERMISSION_KEY.SUPPLIER_CONTACT]: 'Lieferant kontaktieren',
        [PERMISSION_KEY.CHAT_READ]: 'Chat lesen',
        [PERMISSION_KEY.CHAT_CREATE]: 'Nachrichten senden',
    },
    noListEntries: 'Derzeit befinden sich noch keine Artikel in dieser Liste',
    noSearchResults: 'Für deinen Filter wurden keine Artikel gefunden',
    noEntries: 'Keine Elemente vorhanden',
    noMail: 'Keine Mail bekommen',
    login: {
        emailSent: 'Wir haben dir gerade eine Email geschickt',
        setPassword: 'Über den Link kannst du ein neues Passwort vergeben',
        resetPassword: 'Tragen Sie Ihre Emailadresse ein und erhalten Sie ein neues Passwort'
    },
    start: {
        notNew: 'Bereits Kunde',
        new: 'Zum ersten Mal hier'
    },
    cart: {
        amount: '{amount} Artikelpositionen',
        selectionFrom: 'Auswahl bei {deliverer}',
        fromList: 'Aus deinen Listen',
        noList: 'Ohne Liste',
        lastOrder: 'Aus deiner letzten Bestellung',
        amountItems: '{amount} Einzelartikel',
        upgradeToPromotion: 'Fast geschafft! Noch {amount} Stück bis zur {shortTitle} Aktion 🏷️ → jetzt bestellen',
        convertToPromotion: 'Aktion gesichert 🏷️ → jetzt aktivieren'
    },
    register: {
        intro: 'Um dein Profil zu erstellen benötigen wir einige Angaben',
        thank: 'Danke {name}',
        emailSent: '@:messages.login.emailSent',
        validate: 'Bitte bestätige deinen Account über den Link',
        validateEmail: `@:{'messages.register.validate'}, der an deine Email-Adresse geschickt wurde, bevor du bestellen kannst`,
        noCode: 'Ich habe keinen Einladungscode',
        code: 'Ich habe einen Einladungscode erhalten',
        skipEmail: 'Leider konnten wir die von dir eingegebene E-Mail-Adresse nicht finden. Bitte bestätige deine E-Mail-Adresse erneut.'
    },
    didYouMean: 'Suchst du vielleicht nach {target}?',
    didYouCheck: 'Hast du schon alle Lieferanten in der vorherigen Ansicht durchsucht?',
    agbRequired: 'Der Datenschutzbestimmung muss zugestimmt werden.',
    list: {
        repeatEach1: 'Erinnerung',
        repeatEach2: 'Alle',
        noTags: 'Keine Filterkategorien vorhanden. Fügen Sie ihren Listenprodukten Kategorien hinzu.',
        overrideCartList: 'Die Liste befindet sich bereits im Warenkorb. Möchtest du deinen Warenkorb überschreiben?',
        overrideProductList: 'Dieses Produkt befindet sich bereits im Warenkorb. Möchtest du deinen Warenkorb überschreiben?',
        noReminder: 'Bisher wurden keine Bestellwecker für diese Liste angelegt.',
        amountReset: 'Die Produktmengen wurden zurückgesetzt.',
        resetCheck: 'Bist du sicher, dass du alle Mengenangaben dieser Liste auf 0 zurücksetzen möchtest?'
    },
    pressEnter: 'Bestätige auf Tastatur zum Hinzufügen',
    changedEmail: 'Wir haben dir gerade eine Email an die neue Adresse geschickt. Für das Übernehmen der Änderung betätige bitte den versendeten Link.',
    updateLoading: 'Update wird installiert',
    intro: {
        home: {
            msg1: 'Über den Header gelangst du zurück zu deiner Location-Übersicht und dem Warenkorb',
            title1: 'Erreiche deine Locations und den Warenkorb',
            msg2: 'Deine zuletzt getätigten Bestellungen und häufig bestellte Listen erreichst du direkt über das Dashboard.',
            title2: 'Überblick über deine Aktivitäten',
            msg3: 'Über die Menüleiste erreichst du mit nur einem Klick dein Ziel.',
            title3: 'Navigation überall erreichbar'
        },
        list: {
            title1: 'Hier fängt die Bestellung an',
            msg1: 'Über den Header erreichst du deine Listen und den Katalog. Hier kannst du die Artikel deiner Lieferanten durchsuchen.',
            title2: 'Deine Lieferanten',
            msg2: 'Hier kannst du die Bestelllisten deiner Lieferanten ansehen und bearbeiten oder selbst neue Listen erstellen.',
            title3: 'Sortieren und Löschen',
            msg3: 'Tippe das Produktbild an, um einzelne oder mehrere Artikel auszuwählen, per Drag & Drop zu verschieben, oder durch das Mülleimersymbol zu löschen.',
            title4: 'Einfaches Anpassen der Liste',
            msg4: 'Die Menge eines Produkts lässt sich über die Plus- und Minus-Tasten ändern. Swipe nach rechts, um das Produkt aus der Liste zu entfernen.',
            title5: 'Artikel schnell finden',
            msg5: 'Im Katalog kannst du die einzelnen Artikel deiner Lieferanten einsehen, durchsuchen und nach Kategorie filtern.',
        },
        promotion: {
            title1: 'Aktionen und Vorschläge',
            msg1: 'Hier siehst du aktuelle Aktionen, Produktvorschläge oder News deiner Lieferanten oder von Octopus Order.',
            title2: 'Aktionsangebote deiner Lieferanten',
            msg2: 'Hier werden dir Artikel von deinen Lieferanten angezeigt, für die aktuell besondere Aktionen verfügbar sind.',
            title3: 'Aktuelle Vorschläge und News',
            msg3: 'Mit den Produktvorschlägen erhältst du Infos zu den neuesten Trends aus der Getränkebranche. In den News erfährst du alle Neuigkeiten rund um Octopus.',
        },
        setting: {
            msg1: 'Hier kannst du deine Lieferanten und Location verwalten, Einstellungen vornehmen, Bestellungen einsehen oder den Support erreichen.',
            title1: 'App Einstellungen',
            msg2: 'Du kannst hier Wecker einstellen, die dich regelmäßig daran erinnern, deine Liste zu Bestellen.',
            title2: 'Keine Bestellung mehr vergessen',
            msg3: 'Dort kannst du dein Team verwalten und weitere Teammitglieder zu Octopus Order einladen.',
            title3: 'Dein eigenes Team',
            msg4: 'Hier hast du alle deine Lieferanten im Überblick und kannst diese Bearbeiten oder Entfernen sowie neue Lieferanten hinzufügen.',
            title4: 'Lieferantenübersicht',
        }
    },
    ordering: 'Bestellung wird ausgeführt',
    noConnection1: 'Keine Verbindung zum Server',
    noConnection2: 'Bitte überprüfe deine Internetverbindung',
    switchLocation: 'Diese Benachrichtigung gehört zu einer anderen Location. Möchtest du die Location wechseln?',
    containsExpiredPromotion: 'In deinem Warenkorb befindet sich ein abgelaufenes Aktionsitem. Bitte entferne dieses' +
        ' um mit der Bestellung fortzufahren.',
    addProductsViaScanner: "Produkte über Scanner hinzufügen",
    scanDesiredProducts: "Scanne deine gewünschten Produkte",
    scanToAddMoreProducts: "Scannen um weitere Produkte hinzuzufügen",
    updateScanItems: "Möchtest du deine gescannten Artikel zu deiner Liste hinzufügen? Die Anzahl von Artikeln in der Liste wird überschrieben.",
    addScanItems: "Möchtest du deine gescannten Artikel in den Warenkorb legen?",
    holidayDeliveryTitle: 'Der ausgewählte Liefertag ist ein Feiertag!',
    holidayDelivery: 'Bitte erfrage deinen genauen Liefertermin bei deinem Lieferanten. ',
    longOrder: 'Ihre Bestellung liegt mehr als 7 Tage in der Zukunft. Wollen Sie tatsächlich zum {date} bestellen?',
    cartDataMissing: 'Bestelldaten fehlerhaft',
    newBinaryVersion: 'Eine neue Version ist verfügbar und beinhaltet wichtige Änderungen. Bitte aktualisiere deine Version.',
    deliveryDayWarningTitle: 'Das gewählte Datum ist kein regulärer Liefertag!',
    deliveryDayWarning: 'Ausnahmefälle bitte vorab mit dem Lieferanten klären.',
    holidayPickupTitle: 'Der ausgewählte Abholtag ist ein Feiertag!',
    holidayPickup: 'Bitte erfrage deinen genauen Abholtermin bei deinem Lieferanten.',
    modal: {
        updateLocationTypeTitle: 'Deine Auswahl, Dein Vorteil',
        updateLocationTypeDescription: 'Mit der Auswahl Deines Gastronomiebetriebs passen wir Inhalte und Aktionen für Dich an. Du kannst diese Einstellung jederzeit ändern.',
        updateLocationTypeHint: 'Die Auswahl wird nur innerhalb der App genutzt und kann jederzeit angepasst werden.'
    },
    currentLocation: 'Du bist gerade in der Location'
}

export default messagesDE
